export enum SandboxActionTypes {
  CHANGE_MENU_DATA = 'CHANGE_MENU_DATA',
  CHANGE_EDITING_MENU_ID = 'CHANGE_EDITING_MENU_ID',
  CHANGE_SANDBOX_SUMMARY_DATA = 'CHANGE_SANDBOX_SUMMARY_DATA',
  NEW_SANDBOX_CREATED = 'NEW_SANDBOX_CREATED',
  RETRY_SANDBOX_CREATION = 'RETRY_SANDBOX_CREATION',
  TOGGLE_IS_EDITING_SANDBOX = 'TOGGLE_IS_EDITING_SANDBOX',
}
